export const FETCH_END = 'setArticles';
export const FETCH_START = 'setLoading';
export const SET_ERROR = 'setError';
export const RESET_STATE = 'resetModuleState';